var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0001 8.79995C9.99421 8.79995 10.8001 7.99406 10.8001 6.99995C10.8001 6.00584 9.99421 5.19995 9.0001 5.19995C8.00599 5.19995 7.20011 6.00584 7.20011 6.99995C7.20011 7.99406 8.00599 8.79995 9.0001 8.79995Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.412109 6.99999C1.55893 3.34857 4.97019 0.699951 9.00007 0.699951C13.0299 0.699951 16.4412 3.34854 17.588 6.99992C16.4412 10.6513 13.0299 13.3 9.00005 13.3C4.9702 13.3 1.55895 10.6514 0.412109 6.99999ZM12.6001 6.99995C12.6001 8.98818 10.9883 10.6 9.0001 10.6C7.01189 10.6 5.40012 8.98818 5.40012 6.99995C5.40012 5.01173 7.01189 3.39995 9.0001 3.39995C10.9883 3.39995 12.6001 5.01173 12.6001 6.99995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.261fe07b24fa390d69495db385cc55e4.svg";
export { ForwardRef as ReactComponent };